import React from 'react';
import { HourglassIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function UrgencyBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'hrs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  return <div className="w-full bg-urgency py-3 text-white" data-id="element-153" data-mp="32wgt4ikqh19e">
      <p className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 px-5 text-center font-sans text-xs font-bold uppercase tracking-[0.14em] md:text-sm" data-id="element-154" data-mp="2yv534bxy6e0o">
        <HourglassIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-155" data-mp="2u2lorcrfreut" />
        <span data-id="element-156" data-mp="2p6dae1l2bpop">La oferta de lanzamiento finaliza en:</span>
        <span className="inline-flex items-center gap-1.5" role="timer" data-id="element-157" data-mp="2k6qwrr1bo7fd">
          {units.map((unit, index) => <span key={unit.label} className="inline-flex items-center gap-1.5" data-id="element-158" data-mp="2f7nv8gkjwjc5" data-mpi={index}>
              {index > 0 && <span aria-hidden="true" data-id="element-159" data-mp="2b5kf3emxsqkj">:</span>}
              <span className="text-base font-extrabold tabular-nums tracking-normal md:text-lg" data-id="element-160" data-mp="2b7x7ymu8glcd">
                {unit.value}
              </span>
              <span className="text-[0.65rem] font-bold tracking-[0.1em]" data-id="element-161" data-mp="1woapqaq4q5mq">{unit.label}</span>
            </span>)}
        </span>
      </p>
    </div>;
}